import type { JSX } from 'react'

export const BackwardIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use href='#backwardIcon' height='100%' width='100%' />
    <use
      href='#backwardSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
